import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/img/logo-light.svg'


const _withScopeId = n => (_pushScopeId("data-v-cea5a018"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header row no-margin" }
const _hoisted_2 = { class: "nav-bar header-logo" }
const _hoisted_3 = {
  style: {"display":"flex","align-items":"center"},
  class: "float-right"
}
const _hoisted_4 = {
  key: 0,
  class: "float-right m-top-13 d-sm-none d-md-block d-none d-sm-block"
}
const _hoisted_5 = {
  key: 0,
  class: "sign-up"
}
const _hoisted_6 = {
  key: 1,
  style: {"color":"white"},
  class: "sign-up"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_runtime_template = _resolveComponent("v-runtime-template")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "float-left",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.home && _ctx.home(...args)))
      }, [
        (!_ctx.light_logo || null)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: _normalizeClass(["logo", _ctx.showProspectForm ? 'logo-highlight' : '']),
              src: _imports_0
            }, null, 2))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: _normalizeClass(["logo", _ctx.showProspectForm ? 'logo-highlight' : '']),
              src: _imports_1
            }, null, 2))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.pageType === '3' || null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!_ctx.light_logo || null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createVNode(_component_v_runtime_template, { template: _ctx.createAccountText }, null, 8, ["template"])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_v_runtime_template, { template: _ctx.createAccountText }, null, 8, ["template"])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}